import DispatchStore from "./Dispatch/DispatchStore";
import DispatchDashboardStore from "./Dashboard/DispatchDashboard.Store";

const dispatchStoreList = [
    { name: "dispatchStore", store: DispatchStore },
    { name: "dispatchDashboardStore", store: DispatchDashboardStore },
];

export default dispatchStoreList;
